import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Preloader from "@/components/Preloader";

// Pages
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/services/ServiceDetail";
import Work from "@/pages/Work";
import WorkDetail from "@/pages/WorkDetail";
import Contact from "@/pages/Contact";
import BookAppointment from "@/pages/BookAppointment";
import FAQ from "@/pages/FAQ";
import Clients from "@/pages/Clients";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Careers from "@/pages/Careers";
import LandingPage from "@/pages/LandingPage";

// Admin Pages
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminTeam from "@/pages/admin/AdminTeam";
import AdminBlogs from "@/pages/admin/AdminBlogs";
import AdminClients from "@/pages/admin/AdminClients";
import AdminAppointments from "@/pages/admin/AdminAppointments";
import AdminContacts from "@/pages/admin/AdminContacts";
import AdminFAQ from "@/pages/admin/AdminFAQ";
import AdminStats from "@/pages/admin/AdminStats";
import AdminCareers from "@/pages/admin/AdminCareers";
import AdminCaseStudies from "@/pages/admin/AdminCaseStudies";
import ERPDashboard from "@/pages/admin/ERPDashboard";
import ERPClients from "@/pages/admin/ERPClients";
import ERPIncome from "@/pages/admin/ERPIncome";
import ERPExpenses from "@/pages/admin/ERPExpenses";

// Components
import ChatWidget from "@/components/ChatWidget";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const hasSeenPreloader = sessionStorage.getItem('wizbang_preloader_seen');
    if (hasSeenPreloader) setLoading(false);
  }, []);

  const handlePreloaderComplete = () => {
    sessionStorage.setItem('wizbang_preloader_seen', 'true');
    setLoading(false);
  };

  return (
    <div className="App min-h-screen" style={{ background: '#FAFAF7' }}>
      {loading && <Preloader onComplete={handlePreloaderComplete} />}
      <div className="noise-overlay" />
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/work" element={<Work />} />
          <Route path="/work/:slug" element={<WorkDetail />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/book-appointment" element={<BookAppointment />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/grow" element={<LandingPage />} />
          <Route path="/get-started" element={<LandingPage />} />
          <Route path="/free-strategy" element={<LandingPage />} />

          {/* Admin Routes */}
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/team" element={<AdminTeam />} />
          <Route path="/admin/blogs" element={<AdminBlogs />} />
          <Route path="/admin/clients" element={<AdminClients />} />
          <Route path="/admin/appointments" element={<AdminAppointments />} />
          <Route path="/admin/contacts" element={<AdminContacts />} />
          <Route path="/admin/faq" element={<AdminFAQ />} />
          <Route path="/admin/stats" element={<AdminStats />} />
          <Route path="/admin/careers" element={<AdminCareers />} />
          <Route path="/admin/case-studies" element={<AdminCaseStudies />} />

          {/* ERP Routes */}
          <Route path="/admin/erp" element={<ERPDashboard />} />
          <Route path="/admin/erp/clients" element={<ERPClients />} />
          <Route path="/admin/erp/income" element={<ERPIncome />} />
          <Route path="/admin/erp/expenses" element={<ERPExpenses />} />
        </Routes>
        <ChatWidget />
      </BrowserRouter>
      <Toaster position="top-right" theme="light" />
    </div>
  );
}

export default App;
